/* eslint-disable */
import axios from 'axios';
import apiConfig from './utils/api';

const env = process.env.REACT_APP_NODE_ENV;

const getBaseUrl = () => {
  if (env === 'testing') {
    return apiConfig.testing.API_BASE;
  }
  if (env === 'production') {
    return apiConfig.prod.API_BASE;
  }
  return apiConfig.dev.API_BASE;
};

const Axios = axios.create({ baseURL: getBaseUrl()});

/*
const Axios = axios.create({
  baseURL: getBaseUrl(),
  timeout: 20 * 60 * 1000,
  mode: 'no-cors',
  maxBodyLength: 10000000000,
  headers: {
    'Access-Control-Allow-Origin': '*',
    Authorization: `Bearer ${JSON.parse(window.localStorage.getItem('token'))}`,
  },
});
*/


Axios.interceptors.request.use((req) => {
  if (localStorage.getItem('token')) {
    req.headers.Authorization = `Bearer ${JSON.parse(window.localStorage.getItem('token'))}`;
  }
  return req;
});

// Interceptor de respuestas para manejar errores de autorización
Axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    console.log( 'ENTRE AL INTERCEPTOR ');
    
    // Manejar errores de autorización
    if (error.response?.status === 401) {
      if (originalRequest.url === '/usuario/changetoken') {
        // Si el error proviene de la solicitud para cambiar el token, limpiar el almacenamiento local y redirigir al inicio
        window.localStorage.clear();
        window.location.replace('/');
      } else if (!originalRequest._retry && originalRequest.url !== '/usuario/ingresaruser') {
        // Si el error proviene de una solicitud protegida y no es un intento de reintentar,
        // intentar obtener un nuevo token y reenviar la solicitud original
        originalRequest._retry = true;
        try {
          // Aquí debes hacer la solicitud para obtener un nuevo token
          const response = await Axios.post('/usuario/changetoken', {
            refreshToken: window.localStorage.getItem('refreshToken'),
          });

          // Si la solicitud para obtener un nuevo token es exitosa, actualizar el token en el almacenamiento local
          window.localStorage.setItem('token', JSON.stringify(response.data.token));

          // Reintentar la solicitud original con el nuevo token
          originalRequest.headers.Authorization = `Bearer ${JSON.parse(window.localStorage.getItem('token'))}`;
          return Axios(originalRequest);
        } catch (err) {
          // Si la solicitud para obtener un nuevo token falla, limpiar el almacenamiento local y redirigir al inicio
          window.localStorage.clear();
          window.location.replace('/');
        }
      }
    }
    
    if (error.response?.status === 500) {
        window.localStorage.clear();
        window.location.replace('/');
        return Promise.reject(error);
    }
    // Propagar el error si no es un error de autorización
    return Promise.reject(error);
  }
);

Axios.defaults.headers.common['Content-Type'] = 'application/json';

export default Axios;
